<div
    *ngIf="loading || additionalRecipientLoading"
    [agprLoading]="(loading && selectedTabIndex === distributionRecipientType.contacts) || (additionalRecipientLoading &&  selectedTabIndex === distributionRecipientType.others)"
    class="agpr-loadingOverlay"
>
</div>
<div
    [style.display]="selected ? '' : 'none'"
    role="tabpanel"
    [id]="id + '.panel'"
    [attr.aria-labelledby]="id"
    >
    <ng-template #tabHeader>
        <agpr-tabs
            class="agpr-distributionReportTabs"
            [selectedTabIndex]="selectedTabIndex"
            [variableHeaderWidth]="true"
            (selectedTabIndexChange)="tabChange($event)"
        >
            <agpr-tab
                [heading]="'Discover.distribution.recipientTab.contacts' | localize : {count: totalResults}"
                [id]="id + '.contactsTab'"
                tooltip="Discover.distribution.recipientTab.contacts.tooltip"
            >
            </agpr-tab>
            <agpr-tab
                [heading]="'Discover.distribution.recipientTab.others' | localize : {count: totalAdditionalRecipients}"
                [id]="id + '.othersTab'"
            >
            </agpr-tab>
        </agpr-tabs>

        <div
            class="agpr-recipientSearch-recipientToolbar"
            *ngIf="selectedTabIndex === distributionRecipientType.contacts"
        >
            <div class="agpr-recipientSearch-filterToolbar">
                <div class="agpr-recipientSearch-filterToolbar-filterInput">
                    <agpr-filter-dropdown
                        [id]="id + '.resultsFilters'"
                        [showQuickFilter]="true"
                        quickFilterPlaceholder="Discover.targeting.filter.quick.contactName.placeholder"
                        [ariaLabel]="'Discover.distribution.recipients.filterLabel' | localize"
                        [ariaDescribedBy]="id + '.filter.chips'"
                    ></agpr-filter-dropdown>
                </div>
                <agpr-sort-order
                    id="recipientSearch-sortOrder"
                    class="agpr-recipientSearch-filterToolbar-sortOrder"
                    [isDisabled]="!results?.length"
                    tooltip="Discover.targeting.tooltips.sort"
                    optionKey="enumValue"
                    optionLabel="displayString"
                ></agpr-sort-order>
            </div>
            <agpr-filter-chips
                class="agpr-recipientSearch-filterChips"
                *ngIf="chipsVisible"
                [id]="id + '.filter.chips'"
            ></agpr-filter-chips>

            <!-- second row -->
            <div class="agpr-targetingResults-listBuilder-rhp">

                <agpr-dropdown
                    [id]="id + '.targeting.add.to.type'"
                    class="agpr-targetingResults-listBuilder-type"
                    [options]="targetingAddToOptions"
                    [(ngModel)]="addToType"
                    [bindToValue]="true"
                    (ngModelChange)="selectTargetingType()"
                ></agpr-dropdown>

                @if (addToType === targetingAddToTypes.LIST) {
                    <agpr-autocomplete
                        #listBuilderDropdown
                        class="agpr-targetingResults-listBuilder-dropdown"
                        [id]="id + '.listBuilderDropdown'"
                        labelField="name"
                        placeholder="Discover.listBuilder.widget.placeholder.dropdown"
                        [dropdown]="true"
                        dropdownMode="current"
                        [(ngModel)]="selectedLists"
                        [customOptions]="listBuilderOptions"
                        (itemSelected)="updateListBuilder()"
                        [suggestions]="targetingLists$"
                        [multiSelection]="true"
                        [pTooltip]="'Discover.listBuilder.widget.tooltip.dropdown' | localize"
                        tooltipPosition="top"
                        ariaLabel="Discover.listBuilder.widget.placeholder.dropdown"
                        [ariaDescribedBy]="id + '_selectedLists_chips'"
                    ></agpr-autocomplete>
                    <span class="agpr-targetingResults-listBuilder-lock">
                        <agpr-button
                            [ngClass]="{
                                'agpr-targetingResults-toolbarIcon--lock': workingListsLocked,
                                'agpr-targetingResults-toolbarIcon--unlock': !workingListsLocked
                            }"
                            [style]="buttonTypes.icon"
                            [id]="id + '.listBuilder.lock'"
                            (click)="listPickerService.toggleWorkingListsLock()"
                            [icon]="workingListsLocked ? 'fa-regular fa-duotone fa-lock' : 'fa-regular fa-duotone fa-unlock'"
                            [tooltip]="workingListsLocked ? 'Discover.listBuilder.widget.tooltip.unlock' : 'Discover.listBuilder.widget.tooltip.lock'"
                            tooltipPosition="top"
                        ></agpr-button>
                    </span>
                }
                @else {
                    <agpr-autocomplete
                        #listBuilderDropdown
                        class="agpr-targetingResults-listBuilder-dropdown"
                        [id]="id + '.distBuilderDropdown'"
                        labelField="name"
                        placeholder="Discover.distributionBuilder.widget.placeholder.dropdown"
                        [dropdown]="true"
                        dropdownMode="current"
                        [(ngModel)]="selectedDistributions"
                        (itemSelected)="updateDistributionBuilder()"
                        [suggestions]="distributions$"
                        [multiSelection]="true"
                        [pTooltip]="'Discover.distributionBuilder.widget.tooltip.dropdown' | localize"
                        tooltipPosition="top"
                        [ariaLabel]="'Discover.distributionBuilder.widget.placeholder.dropdown'"
                        [showHiddenOption]="true"
                        [ariaDescribedBy]="id + '_selectedDists_chips'"
                    ></agpr-autocomplete>
                    <span class="agpr-targetingResults-listBuilder-lock">
                        <agpr-button
                            [ngClass]="{
                                'agpr-targetingResults-toolbarIcon--lock': workingListsLocked,
                                'agpr-targetingResults-toolbarIcon--unlock': !workingListsLocked
                            }"
                            [style]="buttonTypes.icon"
                            [id]="id + '.distBuilder.lock'"
                            (click)="distributionPickerService.toggleWorkingDistributionsLock()"
                            [icon]="workingDistributionsLocked ? 'fa-regular fa-duotone fa-lock' : 'fa-regular fa-duotone fa-unlock'"
                            [tooltip]="workingDistributionsLocked ? 'Discover.distributionBuilder.widget.tooltip.unlock' : 'Discover.distributionBuilder.widget.tooltip.lock'"
                            tooltipPosition="top"
                        ></agpr-button>
                    </span>
                }
                <agpr-button
                    class="agpr-entityResults-listBuilder-addToButton"
                    [ngClass]="{'agpr-targetingResults-listBuilder-addToDistButton' : addToType === targetingAddToTypes.DISTRIBUTION}"
                    [id]="id + '.addTo'"
                    [style]="buttonTypes.icon"
                    [icon]="addToType === targetingAddToTypes.LIST ? 'fa-regular fa-duotone fa-user-plus' : 'fa-kit-duotone fa-agpr-add-distribution'"
                    [disabled]="!results?.length || selectedResults.length === 0"
                    (click)="addTo()"
                    [tooltip]="addToType === targetingAddToTypes.LIST ? 'Discover.listBuilder.widget.tooltip.addButton' : 'Discover.distributionBuilder.widget.tooltip.addButton'"
                    tooltipPosition="top"
                ></agpr-button>
            </div>

            <!-- third row -->
            @if (selectedListsChips?.length || selectedDistributionsChips?.length) {
                <div  class="agpr-targetingResults-listBuilder-rhp-chipContainer">
                    @if (addToType === targetingAddToTypes.LIST) {
                        <agpr-chip-container
                            #listChipsComponent
                            [id]="id + '.selectedLists.chips'"
                            [chips]="selectedListsChips"
                            (removeChip)="listPickerService.removeWorkingListByIndex($event)"
                        ></agpr-chip-container>
                        <agpr-button
                            *ngIf="selectedLists.length > 1"
                            class="agpr-targetingResults-toolbarIcon-clear"
                            [style]="buttonTypes.link"
                            id="listBuilderClear"
                            (click)="clearListChips()"
                            icon="agpr-i-clear"
                            tooltip="Discover.listBuilder.widget.tooltip.clearAll"
                            tooltipPosition="top"
                        ></agpr-button>
                    }
                    @else {
                        <agpr-chip-container
                            #listChipsComponent
                            [id]="id + '.selectedDistributions.chips'"
                            [chips]="selectedDistributionsChips"
                            (removeChip)="distributionPickerService.removeWorkingDistributionByIndex($event)"
                        ></agpr-chip-container>
                        <agpr-button
                            *ngIf="selectedDistributions.length > 1"
                            [id]="id + '-distributionBuilderClear'"
                            class="agpr-targetingResults-toolbarIcon-clear"
                            [style]="buttonTypes.link"
                            (click)="clearDistributionChips()"
                            icon="fa-kit-duotone fa-agpr-remove-all"
                            tooltip="Discover.distributionBuilder.widget.tooltip.clearAll"
                            tooltipPosition="top"
                        ></agpr-button>
                    }
                </div>
            }

            <!-- bottom row -->
            <div class="agpr-recipientSearch-selectBar agpr-recipientSearch-selectBar-container">
                <agpr-checkbox
                    id="distribution_recipientService_selectAll"
                    [binary]="true"
                    hiddenLabel="selectAll"
                    [disabled]="!totalResults"
                    [ngModel]="results?.length > 0 && selectedResults?.length >= results?.length"
                    (ngModelChange)="toggleSelectAll()"
                >
                    <span class="agpr-recipientSearch-selectBar-totalCount-value">
                        {{ allSelected ? totalResults : (selectedResults?.length || '0') }}
                        <span class="agpr-recipientSearch-selectBar-totalCount-text">
                            {{ 'Paginator.of' | localize }}
                            <span class="agpr-recipientSearch-selectBar-totalCount-value">
                                {{ totalResults || '0'}}
                            </span>
                            {{'Paginator.selected' | localize}}
                        </span>
                    </span>
                </agpr-checkbox>
                <agpr-minimal-paginator [isDisabled]="!totalResults"></agpr-minimal-paginator>
            </div>
            <div
                *ngIf="results?.length > 0 && selectedResults.length >= results?.length && totalResults > selectedResults.length"
                class="agpr-recipientSearch-selectAllNotice"
            >
                <agpr-message severity="info">
                    <span *ngIf="!allSelected">
                        {{
                        'Discover.targeting.result.selectAll.notice.page' | localize : {
                            count: selectedResults.length
                            }
                        }}
                    </span>
                    <span *ngIf="allSelected">
                        {{
                        'Discover.targeting.result.selectAll.notice.all' | localize : {
                            count: totalResults
                            }
                        }}
                    </span>
                    <agpr-button
                        *ngIf="!allSelected"
                        [label]="'Discover.targeting.result.selectAll.hyperlink.select' | localize : {
                            count: totalResults
                        }"
                        (click)="selectAllResults()"
                        [style]="buttonTypes.link"
                        class="agpr-recipientSearch-selectAllNotice-link"
                    ></agpr-button>
                    <agpr-button
                        *ngIf="allSelected"
                        [label]="'Discover.targeting.result.selectAll.hyperlink.clear' | localize"
                        (click)="toggleSelectAll()"
                        [style]="buttonTypes.link"
                        class="agpr-recipientSearch-selectAllNotice-link"
                    ></agpr-button>
                </agpr-message>
            </div>
        </div>
        <div
            class="agpr-recipientSearch-recipientToolbar"
            *ngIf="selectedTabIndex === distributionRecipientType.others"
        >
            <agpr-additional-recipient-toolbar></agpr-additional-recipient-toolbar>
        </div>
    </ng-template>
    <ng-container *ngIf="!loading && selectedTabIndex === distributionRecipientType.contacts">
        <ul
            [id]="id + '_recipientContactList'"
            agprListKeyboardNavigation
            [focusOnChild]="true"
            [list]="results"
            focusableElementCustomSelector=".agpr-targetingResults-card"
        >
            <li *ngFor="let result of results; index as i">
                <agpr-recipient-card
                    [id]="id + '_recipientSearchResultCard_' + i"
                    [entity]="result"
                    [addToType]="addToType"
                    [disableSelection]="allSelected"
                    [selectedResults]="selectedResults"
                    (selectionChanged)="selectedResults = $event"
                    (showRhpTakeOver)="showRhpTakeOver.emit($event)"
                    (viewConversation)="viewConversation($event)"
                    (composeEmail)="composeEmail($event)"
                >
                </agpr-recipient-card>
            </li>
        </ul>
    </ng-container>
    <ng-container *ngIf="!additionalRecipientLoading && selectedTabIndex === distributionRecipientType.others" >
        <ul
            [id]="id + '_additionalRecipientsList'"
            agprListKeyboardNavigation
            [focusOnChild]="true"
            [list]="additionalRecipients"
            focusableElementCustomSelector=".agpr-targetingResults-card"
        >
            <li *ngFor="let result of additionalRecipients">
                <agpr-recipient-card
                    [entity]="result"
                >
                </agpr-recipient-card>
            </li>
        </ul>
    </ng-container>

    <ng-template #tabFooter>
        <agpr-action-bar *ngIf="selectedTabIndex === distributionRecipientType.contacts">
            <ng-template #right>
                <agpr-button
                    label="Discover.targeting.actions.actions"
                    [style]="buttonTypes.tertiary"
                    (click)="openBatchActions()"
                ></agpr-button>
            </ng-template>
        </agpr-action-bar>
    </ng-template>
</div>

